export enum RouterNavigateType {
  None = "NONE",
  Pos = "Pos",
  Restaurant = "Restaurant",
}
